import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { ROUTES } from '@/app/routes';
import { selectIsAuthenticated, selectSessionChecked } from '@/slices/auth';
import { LoadingOverlay } from '@/components/feedback';

// Auth gate for the protected route branch.
export const ProtectedRoute = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const sessionChecked = useAppSelector(selectSessionChecked);

  if (!sessionChecked) {
    return <LoadingOverlay fullscreen />;
  }
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }
  return <Outlet />;
};
